<div class="lg:settings-action-bar max-md:mobile-action-bar z-10" [ngClass]="{'bg-attention-surface':saveReady || undoReady,'bg-standardwhite':!saveReady && !undoReady}">
  <div class=" flex justify-between">
    <div class="flex px-4 pt-3 pb-2">
      <button class=" p-2 hover:bg-grey-300" (click)="goBack()">
      &#60; Back</button>
      <div class="mx-1 border-r-[1px] border-r-grey-500"></div>
      @if (displayActionSectionBar) {
        <button class="text-green-400 p-2 font-semibold" (click)="saveTriggered()" [disabled]="!saveReady"
          [ngClass]="{'hover:bg-grey-300 text-green-400 ':saveReady,'text-grey-900':!saveReady}">
          <div class="flex items-center">
            <span class="material-symbols-outlined mr-1">
              check
            </span>
            <span>Save</span>
          </div>
        </button>
      }
      @if (displayActionSectionBar) {
        <button class="p-2 font-semibold" [disabled]="!undoReady" (click)="undoTriggered()"
          [ngClass]="{'hover:bg-grey-300 text-attention-strong':undoReady,'text-grey-900':!undoReady}">
          <div class="flex items-center">
            <span class="material-symbols-outlined mr-1">
              <span class="material-symbols-outlined">
                restart_alt
              </span>
            </span>
            <span>Undo Changes</span>
          </div>
        </button>
      }
    </div>



  </div>
  @if (false) {
    <p class="text-grey-900 mt-0 py-0 text-xs text-center">There are unsaved changes, moving away from the page will result in these changes being lost.</p>
  }
  <div class="border-solid border-[1px]" [ngClass]="{'border-attention-base':saveReady || undoReady,'border-grey-500':!saveReady && !undoReady}"></div>
</div>
